<template>
  <Buttons :class="componentClasses">
    <TextInput
      :value="value"
      readonly
    />

    <Buttons class="actions" gap="1">
      <StakeTooltip
        :label="copied ? 'Copied!' : 'Copy to clipboard'"
      >
        <Button
          icon-only="fas fa-copy"
          variant="primary"
          outlined
          resize="3"
          :disabled="copied"
          @click="copyToClipboard()"
        />
      </StakeTooltip>

      <slot />
    </Buttons>
  </Buttons>
</template>

<script setup>
import { computed, ref } from 'vue';
import Button from '../button/Button.vue';
import Buttons from '../button/Buttons.vue';
import StakeTooltip from '../../StakeTooltip.vue';
import TextInput from '../input/TextInput.vue';

const props = defineProps({
  size: {
    type: String,
    required: false,
  },
  value: {
    type: String,
    required: true,
  },
});

const copied = ref(false);

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(props.value);
    copied.value = true;
    setTimeout(() => (copied.value = false), 1000);
  } catch (err) {
    console.error('Failed to copy:', err);
  }
};

const componentClasses = computed(() => [
  'tw-relative',
  props.size ? `stk-size-${props.size}` : '',
]);
</script>

<style scoped>
.actions {
  position: absolute;
  right: 0.375em;
}
</style>